import yellowVestStore from './store'

export default class YellowVestModule {
  name = 'yellowVest'
  constructor({ store }) {
    store.registerModule(this.name, yellowVestStore)
  }
}
